import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import TwoColumnLayout from "layout/TwoColumnLayout";
import moment from "moment";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { useLoaderData } from "react-router";

const ICalendarTemplateList = () => {
  const viewModel = useLoaderData<server.viewmodel.ICalendarTemplateListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="iCalendarTemplate_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.ICalendarTemplate.List}
        getId={item => item.iCalendarTemplateId}
        onNew={() => window.location.href = routes.iCalendarTemplate_New().absolute}
        layout={{
          type: "table",
          columns: [
            { header: RESX.GeneralLabels.Title, render: item => <a href={routes.iCalendarTemplate_Detail(item.iCalendarTemplateId).absolute}>{item.title}</a>, key: "title" },
            { header: RESX.GeneralLabels.LastModified, render: item => moment.utc(item.lastModifiedUtc).fromNow(), key: "lastModified" }
          ]
        }}
        filters={<KeywordFilter placeholder={RESX.GeneralLabels.Search} />}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
};

export default ICalendarTemplateList;